export default __webpack_public_path__ + "static/media/slack-2.b80c0a63.svg";